import PropTypes from "prop-types";
import React from "react";
import { getBoxPaddings, safeMerge } from "../../common/utilities";
/**
 *
 * Box is a private component that should be used by any public
 * components that may need to add spacing around themselves.
 *
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function Box(_ref) {
  let {
    spacing,
    className,
    children,
    display
  } = _ref;
  let cssRoot = {
    height: "100%",
    display
  };
  cssRoot = safeMerge(cssRoot, getBoxPaddings(spacing));
  return _jsx("span", {
    className: `pnr-outer-box ${className}`,
    css: cssRoot,
    children: children
  });
}

Box.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The body of the Box. */
  children: PropTypes.node.isRequired,

  /** CSS classes to add to the Box. */
  className: PropTypes.string,

  /** CSS display. */
  display: PropTypes.string,

  /** An object representing the spacing to add to the box. */
  spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape()])
} : {};
Box.defaultProps = {
  className: "",
  display: "inline-block",
  spacing: {}
};
export default Box;